var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Colored-/-Total",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32c15.877 0 16-7.163 16-16S31.877 0 16 0 0 7.163 0 16s.123 16 16 16z",
    id: "Path",
    fill: "#815EFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Seat-Icon",
    transform: "translate(9 9)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0a1 1 0 011 1v4h-1a1 1 0 00-.993.883L11 6v3H4V6a1 1 0 00-1-1H2V1a1 1 0 011-1h9z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 13v1.5a.5.5 0 11-1 0V13a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 011 1v3h9V7a1 1 0 011-1h1a1 1 0 011 1v5a1 1 0 01-1 1v1.5a.5.5 0 11-1 0V13H2z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.d3726778.svg";
export { ForwardRef as ReactComponent };